// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"35eed0f9","875":"0051186a"}[chunkId] + ".chunk.css";
};